import Kml from "../components/setting/kml/Kml";

const KmlPage = () =>{

    return(
        <Kml/>
    )
}

export default KmlPage;